module.exports = __webpack_public_path__ + "img/dauntless.0966f4f2.png";